import _ from 'lodash'

import { searchAPI } from '../../api'
import { types as filteredSearchTypes } from './filteredSearch.module'


const DEFAULT_STATE = {
  activeFilterIds: [],
  filterIdsBlacklist: []  // filter IDs to be ignored/removed before sending to search
}

// Actions
export const types = {
  UPDATE_ACTIVE_FILTER_IDS: 'gulftree/filters/UPDATE_ACTIVE_FILTER_IDS',
  UPDATE_ID_BLACKLIST: 'gulftree/filters/UPDATE_ID_BLACKLIST',
}

// Reducer
export default function reducer(state = DEFAULT_STATE, action = {}) {
  switch (action.type) {

    case types.UPDATE_ACTIVE_FILTER_IDS:
      return {
        ...state,
        activeFilterIds: action.payload
      }

    case types.UPDATE_ID_BLACKLIST:
      return {
        ...state,
        filterIdsBlacklist: action.payload
      }

    default:
      return state;
  }
}

// Action Creators
export function setActiveFilterIds(activeFilterIds, suppressApiRequest) {
  return (dispatch, getState) => {
    dispatch({
      type: types.UPDATE_ACTIVE_FILTER_IDS,
      payload: activeFilterIds
    })

    // Then make service request to get match results unless suppressed by caller
    if (!suppressApiRequest) {
      dispatch({ type: filteredSearchTypes.IS_FETCHING_MATCHES, payload: true })

      // Remove blacklisted filter IDs from IDs sent to server
      const blacklistIds = getState().filters.filterIdsBlacklist
      const updatedActiveFilterIds = _.difference(activeFilterIds, blacklistIds)

      searchAPI.getMatches(updatedActiveFilterIds)
        .then(res => {
          dispatch({ type: filteredSearchTypes.RESET_RESULTS })
          dispatch({ type: filteredSearchTypes.SET_MATCHES, payload: res })
          dispatch({ type: filteredSearchTypes.IS_FETCHING_MATCHES, payload: false })
        })
        .catch(err => err)
    }
  }
}
